export default __webpack_public_path__ + "static/linkedin-2dd6941de51fc060dd6419e99e9cc646.svg";